
/*eslint-disable*/
import VueCountryIntl from "vue-country-intl";
import "vue-country-intl/lib/vue-country-intl.css";
import { check, commonApi } from "@/common/index";
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Countdown from 'vux/src/components/countdown/index.vue'

import {
ValidateRequire,
validataPhone,
validataPhpPhone,
} from "@/common/utils/validate.js";
import { mapState } from "vuex";
export default {
name: "authenticationPhone",
components: { Group, XInput, XButton, Countdown, VueCountryIntl },
data() {
return {
showCountdown: true,
time: 60,
disabled: false,
start: false,
verifCode: "",
query: {
areaCode: null,
phone: "",
UUID: "",
},
isReady: true,
newPhone: null,

countriesList: [],
nowCountry: [""],
};
},
created() {
this.query.UUID = this.$Cookies.get("UUID");
const { mobileValid, mobilePhone } = this.$store.state.userInfo.userInfo;
this.disabled = mobileValid;
if (mobileValid || mobilePhone) this.query.phone = mobilePhone;
},
mounted() {
this.updateCountryCode();
},
methods: {
haveComTotas(data) {
this.$vux.toast.show({ text: data, type: "cancel" });
},
confirmPhone() {
if (!this.checkForm()) return;
if (this.isReady) {
this.isReady = false;
commonApi.CONFIRM.confirmPhone({
...this.query,
phoneYzm: this.verifCode,
})
.then((data) => {
this.isReady = true;
const { title, successTips } = this.$t("mine").mobileAuth;
this.$store.dispatch("getFirstInfo"); 
this.$router.replace({
path: "/My/AccountManat",
query: { title, desc: successTips },
});
})
.catch((err) => {
this.isReady = true;
this.haveComTotas(err);
});
}
},
handesendCode() {
if (this.$store.state.userInfo.userInfo.mobileValid) {
this.haveComToast(this.$t("mine.mobileAuth.authenticated"), "cancel");
return;
}

if (!this.query.areaCode) {
this.haveComTotas("请选择区号", "cancel");
return;
}

if (
(!validataPhone(this.query.phone) && this.query.areaCode === "86") ||
(this.query.areaCode === "63" && !validataPhpPhone(this.query.phone))
) {
this.haveComTotas(this.$t("mine.mobileAuth.phonePlace"));
return;
}
this.disabled = true;
this.start = true;
commonApi.CONFIRM.sendPhoneColor(this.query)
.then((data) => {
this.newPhone = this.query.phone;
})
.catch((err) => {
this.finishFun();
this.haveComTotas(err);
});
},

finishFun() {
this.disabled = false;
this.start = false;
this.time = 60;
},

checkForm() {




if (!this.query.areaCode) {
this.haveComTotas("请选择区号", "cancel");
return;
}
if (
(!validataPhone(this.query.phone) && this.query.areaCode === "86") ||
(this.query.areaCode === "63" && !validataPhpPhone(this.query.phone))
) {
this.haveComTotas(this.$t("mine.mobileAuth.phonePlace"));
return;
}
if (
this.$store.state.linkList.isPhoneVerify === "1" &&
!ValidateRequire(this.verifCode)
) {
this.haveComTotas(this.$t("mine.mobileAuth.verifCodePlace"));
return;
}
if (this.newPhone && this.newPhone !== this.query.phone) {
this.haveComTotas(this.$t("mine.mobileAuth.phoneError"));
return;
}
return true;
},

updateCountryCode() {
const phone = this.query.phone;
if (validataPhone(phone)) {
this.query.areaCode = "86"; 
} else if (validataPhpPhone(phone)) {
this.query.areaCode = "63"; 
} else {
this.query.areaCode = ""; 
}
},
},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/AccountManat/mobileAuth.vue